import { formatters } from '@debatdirect/debatdirect-modules/common';
import AppView from '@debatdirect/debatdirect-modules/containers/AppView/AppView';
import Downloads from '@debatdirect/debatdirect-modules/pages/Downloads/Downloads';
import DebateEmbedded from '@debatdirect/debatdirect-modules/pages/Embedded/DebateEmbeddedComponent';
import LocationEmbedded from '@debatdirect/debatdirect-modules/pages/Embedded/LocationEmbeddedComponent';
import Support from '@debatdirect/debatdirect-modules/pages/Support/Support';
import Politicians from '@debatdirect/debatdirect-modules/pages/Politicians/Politicians';
import LocationPlenary from '@debatdirect/debatdirect-modules/pages/LocationPlenary/LocationPlenary';
import Index from '@debatdirect/debatdirect-modules/pages/Index/Index';
import GenericError from '@debatdirect/debatdirect-modules/pages/GenericError/GenericError';
import Disclaimer from '@debatdirect/debatdirect-modules/pages/Disclaimer/Disclaimer';
import DebateVideo from '@debatdirect/debatdirect-modules/pages/DebateVideo/DebateVideo';
import DebateSwitcher from '@debatdirect/debatdirect-modules/pages/DebateSwitcher/DebateSwitcher';
import DebateSubject from '@debatdirect/debatdirect-modules/pages/DebateSubject/DebateSubject';
import DebateMarkers from '@debatdirect/debatdirect-modules/pages/DebateMarkers/DebateMarkers';
import DebateLocation from '@debatdirect/debatdirect-modules/pages/DebateLocation/DebateLocation';
import DebateDocuments from '@debatdirect/debatdirect-modules/pages/DebateDocuments/DebateDocuments';
import AboutComponent from '@debatdirect/debatdirect-modules/pages/About/About';
import Votings from '@debatdirect/debatdirect-modules/pages/Votings/Votings';
import Kamerbeelden from '@debatdirect/debatdirect-modules/pages/Kamerbeelden/Kamerbeelden';
import Search from '@debatdirect/debatdirect-modules/pages/Search/Search';
import UserPreference from '@debatdirect/debatdirect-modules/pages/UserPreference/UserPreference';

export default {
  path       : '/',
  component  : AppView,
  indexRoute : {
    name     : 'home',
    component: Index,
    title    : 'Deze week in de Tweede Kamer'
  },
  childRoutes: [
    {
      name       : 'index-for-date',
      path       : 'agenda/(:date)',
      component  : Index,
      title      : formatters.formatNavBarTitle,
      childRoutes: [
        {
          name     : 'category',
          path     : ':category',
          component: Index,
          title    : formatters.formatNavBarTitle
        }
      ]
    },
    {
      name     : 'votings',
      path     : 'stemmingen',
      title    : 'Stemmingen van deze week',
      component: Votings
    },
    {
      name     : 'location-plenary',
      path     : 'zalen/plenaire-zaal',
      title    : 'Over de Plenaire Zaal',
      component: LocationPlenary
    },
    {
      name     : 'parliament-members',
      path     : 'personen/kamerleden',
      title    : 'Kamerleden',
      component: Politicians
    },
    {
      name     : 'cabinet-members',
      path     : 'personen/kabinetsleden',
      title    : 'Kabinetsleden',
      component: Politicians
    },
    {
      name     : 'location-embedded',
      path     : 'zaal-embedded/:location',
      title    : 'Zaal embed',
      component: LocationEmbedded,
    },
    {
      name     : 'location-embedded-audio',
      path     : 'zaal-embedded-audio/:location',
      title    : 'Zaal embed (audio)',
      component: LocationEmbedded,
    },
    {
      name         : 'debate',
      path         : ':date/:category/:location/:debate',
      component    : DebateSwitcher,
      indexRedirect: 'debate-subject',
      childRoutes  : [
        {
          path     : 'onderwerp',
          name     : 'debate-subject',
          component: DebateSubject
        }, {
          name     : 'debate-video',
          path     : 'video',
          component: DebateVideo
        }, {
          name     : 'debate-markers',
          path     : 'markeringen',
          component: DebateMarkers
        }, {
          name     : 'debate-location',
          path     : 'in-de-zaal',
          component: DebateLocation
        }, {
          name     : 'debate-documents',
          path     : 'stukken',
          component: DebateDocuments
        },
        {
          name     : 'debate-embedded',
          path     : 'embedded',
          component: DebateEmbedded
        }
      ]
    }, {
      name     : 'about',
      path     : 'about',
      title    : 'Over Debat Direct',
      component: AboutComponent
    }, {
      name     : 'disclaimer',
      path     : 'disclaimer',
      title    : 'Disclaimer',
      component: Disclaimer
    }, {
      name     : 'support',
      path     : 'support/(:faq)',
      title    : 'Support',
      component: Support
    }, {
      name     : 'kamerbeelden',
      path     : 'kamerbeelden',
      title    : 'Kamerbeelden',
      component: Kamerbeelden
    }, {
      name     : 'downloads',
      path     : 'downloads',
      title    : 'Downloads',
      component: Downloads
    }, {
      name     : 'search',
      path     : 'search',
      title    : 'Zoek debatten',
      component: Search
    }, {
      name     : 'preference',
      path     : 'voorkeuren',
      title    : 'Voorkeur profielen',
      component: UserPreference
    }, {
      name     : 'error',
      path     : '*',
      title    : 'Foutmelding',
      component: GenericError
    },
  ],
};



// WEBPACK FOOTER //
// ./src/routes.js